<template>
  <v-text-field  :label="label" clearable v-model="modelValue" type="date" dense hide-details></v-text-field>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import utils from "../utils";

export default defineComponent({
  name: "DateField",
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    modelValue: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const modelValue = computed({
      get() {
        return props.modelValue ? utils.toDateTime(props.modelValue).toISODate() : null;
      },
      set(val: string | null) {
        if (!val) {
          emit('update:modelValue', null);
          return;
        }
        const d = utils.toDateTime(val);
        emit('update:modelValue', d.toISO());
      }
    });

    return {
      modelValue
    };
  }
});
</script>



<style scoped>

</style>
